document.addEventListener('DOMContentLoaded', function() {
  console.log('Cookie management script loaded');
  
  // Check if Shopify object exists
  if (typeof window.Shopify === 'undefined') {
    console.error('Shopify object not found. This script requires Shopify environment.');
    return;
  }

  document.addEventListener('click', function(event) {
    const clickedLink = event.target.closest('a');

    if (clickedLink) {
      const href = clickedLink.getAttribute('href') || '';
      
      // Check if link ends with #manage-cookies (handles language URLs too)
      if (href.endsWith('#manage-cookies')) {
        console.log('Manage cookies link detected!');
        event.preventDefault();
        
        // Check if Customer Privacy API is already available
        if (window.Shopify.customerPrivacy) {
          console.log('Customer Privacy API already available');
          handleCookieManagement();
        } else {
          // Load the Customer Privacy API
          console.log('Loading Shopify Customer Privacy API...');
          window.Shopify.loadFeatures([{
            name: "consent-tracking-api",
            version: "0.1"
          }], function(error) {
            if (error) {
              console.error('Failed to load Customer Privacy API:', error);
              alert('Cookie management system could not be loaded. Please try again.');
              return;
            }
            console.log('Customer Privacy API loaded successfully');
            handleCookieManagement();
          });
        }
      }
    }
  });

  function handleCookieManagement() {
    console.log('Handling cookie management...');
    
    // Method 1: Try using privacyBanner.showPreferences() (recommended by Shopify docs)
    if (typeof window.privacyBanner !== 'undefined' && window.privacyBanner && window.privacyBanner.showPreferences) {
      console.log('Using privacyBanner.showPreferences() method...');
      
      try {
        window.privacyBanner.showPreferences().then(function() {
          console.log('Privacy preferences modal opened successfully');
        }).catch(function(err) {
          console.log('privacyBanner.showPreferences() failed:', err);
          tryAlternativeMethods();
        });
      } catch (e) {
        console.log('Error calling privacyBanner.showPreferences():', e);
        tryAlternativeMethods();
      }
    } else {
      console.log('privacyBanner.showPreferences() not available, trying alternatives...');
      tryAlternativeMethods();
    }
  }

  function tryAlternativeMethods() {
    console.log('Trying alternative methods...');
    
    // Method 2: Try opening existing cookie-bar element
    const cookieBar = document.querySelector('cookie-bar');
    console.log('Cookie bar element found:', cookieBar);

    if (cookieBar) {
      console.log('Opening cookie bar element...');
      cookieBar.open = true;
      cookieBar.style.display = 'block';
      
      // Scroll to the cookie bar
      setTimeout(function() {
        cookieBar.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'nearest' 
        });
        console.log('Scrolled to cookie bar');
      }, 100);
      return;
    }

    // Method 3: Look for other privacy elements
    const privacyElements = [
      'cookie-bar',
      '[data-privacy-banner]',
      '.privacy-banner',
      '.cookie-banner',
      '#privacy-banner',
      '#cookie-banner'
    ];
    
    for (let selector of privacyElements) {
      const element = document.querySelector(selector);
      if (element) {
        console.log('Found privacy element:', selector);
        element.style.display = 'block';
        if (element.open !== undefined) element.open = true;
        if (element.show && typeof element.show === 'function') element.show();
        return;
      }
    }

    // Method 4: Check Shopify Customer Privacy status
    if (window.Shopify && window.Shopify.customerPrivacy) {
      const shouldShow = window.Shopify.customerPrivacy.shouldShowBanner && window.Shopify.customerPrivacy.shouldShowBanner();
      console.log('Should show banner:', shouldShow);
      
      if (shouldShow) {
        console.log('Shopify says banner should be shown, but no cookie bar found');
        alert('Cookie preferences are available but the interface could not be loaded. Please enable the privacy bar in theme settings.');
      } else {
        console.log('Showing custom consent interface...');
        showCustomConsentInterface();
      }
    } else {
      console.log('Customer Privacy API not available, showing fallback');
      alert('Cookie management is not properly configured. Please contact site administrator.');
    }
  }

  function showCustomConsentInterface() {
    try {
      const currentConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
      const region = window.Shopify.customerPrivacy.getRegion();

      let message = 'Current Cookie Preferences:\n\n';
      message += 'Analytics: ' + (currentConsent.analytics || 'Not set') + '\n';
      message += 'Marketing: ' + (currentConsent.marketing || 'Not set') + '\n';
      message += 'Preferences: ' + (currentConsent.preferences || 'Not set') + '\n';
      message += 'Sale of Data: ' + (currentConsent.sale_of_data || 'Not set') + '\n';
      message += '\nRegion: ' + (region || 'Unknown') + '\n\n';
      message += 'Would you like to reset your preferences?';

      if (confirm(message)) {
        console.log('User wants to reset preferences');
        
        // Reset consent (this will likely trigger the banner to show)
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: false,
          marketing: false,
          preferences: false
        }, function() {
          console.log('Consent reset, reloading page to show banner');
          setTimeout(function() {
            window.location.reload();
          }, 1000);
        });
      }
    } catch (e) {
      console.error('Error in custom consent interface:', e);
      alert('Unable to access cookie preferences. Please try again later.');
    }
  }
});